// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_zGn","cls2":"FullScreenPremiumModal-cls2_QGO FullScreenPremiumModal-cls1_zGn"};